import React, { useMemo } from 'react';
import * as Styled from './styled';
import PropTypes from 'prop-types';
import { noop } from '../../../../util/lodashlike';
import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

const BarChartContainer = ({
  legend,
  currentItems,
  isSelectable,
  selectedItemId,
  onSelect,
  highestTick
}) => {
  const itemsWithSortedBars = useMemo(() => {
    return currentItems.map(({ id, name, total, ...bars }, itemIndex) => (
      <Styled.BarChartCol
        isSelectable={isSelectable ?? false}
        isActive={selectedItemId === id ? true : false}
        onClick={onSelect ? () => onSelect(id) : noop}
        key={`bar-column-${itemIndex}`}>
        <Styled.BarSingleBox isSelectable={isSelectable ?? false}>
          <Styled.BarSingleBoxUL>
            <Styled.BarSingleBoxLI>
              {legend.map((l) => {
                return Object.entries(bars).map(
                  ([fieldKey, height], fieldIndex) => {
                    if (l.fieldKey === fieldKey && height > 0) {
                      return (
                        <Styled.SingleBar
                          key={`bar-${fieldIndex}`}
                          height={height}
                          highestTick={highestTick}
                          color={l.color}>
                          <Styled.SingleBarCount>
                            {height}
                          </Styled.SingleBarCount>
                        </Styled.SingleBar>
                      );
                    }
                  }
                );
              })}
            </Styled.BarSingleBoxLI>
          </Styled.BarSingleBoxUL>
          <Styled.BarStatusTotalCount>
            <Styled.BarStatusTotalCountValue>
              {total ?? 0}
            </Styled.BarStatusTotalCountValue>
          </Styled.BarStatusTotalCount>
        </Styled.BarSingleBox>
        <Styled.BarChartFooter
          isSelectable={isSelectable ?? false}
          isActive={selectedItemId === id ? true : false}>
          <StyledNameContainer>
            <StyledName title={name}>{name}</StyledName>
          </StyledNameContainer>
        </Styled.BarChartFooter>
      </Styled.BarChartCol>
    ));
  }, [currentItems, legend]);

  return (
    <Styled.BarChartContainer>
      <Styled.BarChart>{itemsWithSortedBars}</Styled.BarChart>
    </Styled.BarChartContainer>
  );
};

const StyledName = styled.div`
  width: 75%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #31394d;
`;

const StyledNameContainer = styled.div`
  display: flex;
  justify-content: center;
`;

BarChartContainer.propTypes = {
  legend: PropTypes.arrayOf(
    PropTypes.shape({
      fieldKey: PropTypes.string.isRequired,
      fieldName: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ).isRequired,
  currentItems: PropTypes.array.isRequired,
  isSelectable: PropTypes.bool.isRequired,
  selectedItemId: PropTypes.number,
  onSelect: PropTypes.func,
  highestTick: PropTypes.number.isRequired
};

export default BarChartContainer;
